import { ParseQuery } from './parse-query';

export class TranslatableQuery<T extends Parse.Object> extends ParseQuery<T> {
  public searchTranslationKey(key: string, searchText: string, lang: string) {
    this.searchKey(key + '_' + lang, searchText);
    return this;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/queries/translatable-query.ts